<template>
  <div class="ai-writer-root">
    <div class="ai-writer-main-area final-result-bg">
      <div class="ai-writer-main-area-container">
        <div class="main-except-sidebar">
          <!-- v2 hero (gradient banner): title + report meta + external page
               link + keyword pill — same info the old head showed. -->
          <div class="wg-hero-wrap">
            <hero
              title="Content viewer"
              :keyword="keyword"
              :page-run="pageRun"
              hide-mode
              info-title="The article POP wrote for this report. Double-click the content to edit it."
            />
          </div>

          <div class="px-5">
            <!-- Publish-style grid: article left, sidebar cards right (sticky). -->
            <div class="wg-grid">
              <div class="wg-main">
                <white-glove-article-preview
                  :keyword="keyword"
                  :wysiwygBody="wysiwygBody"
                  :wysiwygHead="wysiwygHead"
                  :page-run="pageRun"
                  @update:wysiwygBody="$emit('update:wysiwygBody', $event)"
                  @update:wysiwygHead="$emit('update:wysiwygHead', $event)"
                  @content-changed="$emit('content-changed')"
                />
              </div>
              <aside v-if="$slots.sidebar" class="wg-side">
                <slot name="sidebar" />
              </aside>
            </div>

            <div class="pb-10" />
          </div>
        </div>
      </div>
    </div>

    <white-glove-editor-footer
      :downloadReport="downloadReport"
      :sourceType="sourceType"
      :needsToSave="needsToSave"
      @save="$emit('save')"
      @save-revision="$emit('save-revision')"
    />
  </div>
</template>

<script>
import Hero from "../AiWriter/v2/components/Hero.vue";
import WhiteGloveArticlePreview from "./WhiteGloveArticlePreview.vue";
import WhiteGloveEditorFooter from "./WhiteGloveEditorFooter.vue";

export default {
    name: "WhiteGloveEditor",
    components: {
        Hero,
        WhiteGloveArticlePreview,
        WhiteGloveEditorFooter,
    },
    props: {
        keyword: {
            type: String,
            default: "",
        },
        wysiwygBody: {
            type: String,
            default: "",
        },
        wysiwygHead: {
            type: String,
            default: "",
        },
        downloadReport: {
            type: Function,
            default: null,
        },
        sourceType: {
            type: [Number, String],
            required: true,
        },
        pageRun: {
            type: Object,
            default: () => ({}),
        },
        page: {
            type: Object,
            default: () => ({}),
        },
        // Dirty flag from the parent editor (drives the footer Save state).
        needsToSave: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./white-glove-ai-writer-layout.scss";

/* v2 look: Mulish + hero spacing + the read-only pill (Hero's #pill slot). */
.ai-writer-root {
  font-family: "Mulish", system-ui, sans-serif;
}
.wg-hero-wrap {
  padding: 20px 20px 0;
}
/* Publish-style two-column grid (mirrors .aiw2-publish / .publish-side). */
.wg-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 24px;
  align-items: start;
}
.wg-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: sticky;
  top: 18px;
}
@media (max-width: 900px) {
  .wg-grid {
    grid-template-columns: 1fr;
  }
  .wg-side {
    position: static;
  }
}
</style>
